import { useState, useEffect } from 'react';

const useDebouncedValue = (initialValue, delay) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setValue(initialValue);
    }, delay);

    return () => {
      clearTimeout(timerId);
    };
  }, [initialValue, delay]);

  return value;
};

export default useDebouncedValue;